var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditPencilIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 15.9708H3.914L13.228 6.65679L11.814 5.24279L2.5 14.5568V15.9708ZM18.5 17.9708H0.5V13.7278L13.935 0.292787C14.1225 0.105316 14.3768 0 14.642 0C14.9072 0 15.1615 0.105316 15.349 0.292787L18.178 3.12179C18.3655 3.30931 18.4708 3.56362 18.4708 3.82879C18.4708 4.09395 18.3655 4.34826 18.178 4.53579L6.743 15.9708H18.5V17.9708ZM13.228 3.82879L14.642 5.24279L16.056 3.82879L14.642 2.41479L13.228 3.82879Z",
    fill: "#363853"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditPencilIcon);
export default __webpack_public_path__ + "static/media/editPencilIcon.bed8056d5332dfbf43ffc2d29559c9a9.svg";
export { ForwardRef as ReactComponent };